import React from "react";
import { AUDIENCE_FIELDS } from "../../utils/constants/AdIntelligence";
import FieldNote from "./FieldNote";
import ModelNote from "./ModelNote";

/** The audience fields the model answered, each with its reason and a reviewer note; read-only values. */
const AudienceReview = ({ audience, reasoning, notes, onNoteChange }) => {
  const fields = AUDIENCE_FIELDS.filter(
    ({ key }) => audience?.[key] || reasoning?.[key]
  );
  if (fields.length === 0) return null;

  return (
    <div className="rounded-lg bg-gray-50 px-3 py-3">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        Audience
      </p>
      <div className="grid gap-3 sm:grid-cols-[120px_1fr] sm:items-start">
        {fields.map(({ key, label }) => (
          <React.Fragment key={key}>
            <p className="text-xs font-medium text-gray-500">{label}</p>
            <div>
              {audience?.[key] && (
                <p className="px-1 text-sm text-gray-900">{audience[key]}</p>
              )}
              <ModelNote text={reasoning?.[key]} />
              {onNoteChange && (
                <FieldNote
                  value={notes?.[key]}
                  onChange={(text) => onNoteChange({ key, text })}
                />
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default AudienceReview;
